// UAT feedback. Persisted server-side (see services/feedbackService.ts); each
// person sees only their own submissions unless they hold feedback.manage.
import { createFeedback, listMyFeedback, type FeedbackEntry, type NewFeedback } from '../services/feedbackService';

export type { FeedbackSource, FeedbackEntry, NewFeedback } from '../services/feedbackService';

export async function loadFeedback(username: string | undefined): Promise<FeedbackEntry[]> {
  if (!username) return [];
  return listMyFeedback();
}

export async function saveFeedback(input: NewFeedback): Promise<FeedbackEntry> {
  return createFeedback(input);
}

export function formatFeedbackTime(iso: string): string {
  return new Date(iso).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

// The email the dev team gets for one submission.
export function feedbackEmail(e: FeedbackEntry): { to: string; subject: string; body: string } {
  const lines = [
    `${e.by.name} (${e.by.role}) sent feedback from Ace UAT.`,
    '',
    `Type: ${e.kind ?? 'Not given'}`,
    ...(e.reasons.length ? [`What was off: ${e.reasons.join(', ')}`] : []),
    `Page: ${e.page.label} (${e.page.path})`,
    ...(e.about ? [`About: ${e.about}`] : []),
    `Sent: ${formatFeedbackTime(e.at)}`,
    '',
    e.note || '(No note added)',
  ];
  return {
    to: 'Ace dev team',
    subject: `[Ace UAT] ${e.kind ?? 'Feedback'}: ${e.about ?? e.page.label}`,
    body: lines.join('\n'),
  };
}
